import type { TUserDetailsStoreState } from 'stores/userDetailsStore/userDetailsStore'
import { userDetailsStore } from 'stores/userDetailsStore/userDetailsStore'

export const isSemiosEmployeeOrTester = (s: TUserDetailsStoreState = userDetailsStore.getState()) => {
  return s.accountType === 'EMPLOYEE' || s.accountType === 'TESTER'
}
